import React, { FC } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grow from "@mui/material/Grow";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useDLSelection from "./useDLSelection";

const StyledImg = styled("img")({
  height: 300,
  width: 150,
});

const StyledFormControl = styled(FormControl)({
  width: 270,
  paddingBottom: 10,
});

interface DLselectionProps {
  panelLayout: string;
  layout?: string;
  dlo?: string;
  swingSidelite?: boolean;
}

const DLselection: FC<DLselectionProps> = ({
  panelLayout = "",
  layout = "",
  dlo = "",
  swingSidelite = false,
}) => {
  const {
    options,
    liteImage,
    isCottage,
    filterSwingSideliteOptions,
    handleDOChange,
    handleChange,
    text,
    isSDL
  } = useDLSelection(panelLayout, layout, swingSidelite);

  return (
    <RowLayout style={{ paddingRight: 20 }}>
      <ColLayout style={{ paddingRight: 20 }}>
        <StyledFormControl required>
          <InputLabel>
            {text} {swingSidelite && "Sidelite"} Configuration
          </InputLabel>
          {swingSidelite ? (
            <Select
              onChange={handleChange}
              value={layout}
              label={`${text} ${swingSidelite && "Sidelite"} Configuration`}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {filterSwingSideliteOptions(panelLayout).map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          ) : (
             <Select
              onChange={handleChange}
              value={layout}
              label={`${text} ${swingSidelite && "Sidelite"} Configuration`}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {options.map((item) => (
                <MenuItem key={item.label} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          )}
          <FormHelperText>Required</FormHelperText>
        </StyledFormControl>
        {isCottage && !swingSidelite && (
          <StyledFormControl required>
            <InputLabel>Daylight Opening (Enter value for X)</InputLabel>
            {isSDL ? (
              <Select
                onChange={handleDOChange}
                value={dlo}
                label="Daylight Opening (Enter value for X)"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'5"'}>5 Inches</MenuItem>
                <MenuItem value={'6"'}>6 Inches</MenuItem>
                <MenuItem value={'7"'}>7 Inches</MenuItem>
                <MenuItem value={'8"'}>8 Inches</MenuItem>
                <MenuItem value={'9"'}>9 Inches</MenuItem>
                <MenuItem value={'10"'}>10 Inches</MenuItem>
                <MenuItem value={'11"'}>11 Inches</MenuItem>
                <MenuItem value={'12"'}>12 Inches</MenuItem>
                <MenuItem value={'13"'}>13 Inches</MenuItem>
                <MenuItem value={'14"'}>14 Inches</MenuItem>
                <MenuItem value={'15"'}>15 Inches</MenuItem>
                <MenuItem value={'16"'}>16 Inches</MenuItem>
                <MenuItem value={'17"'}>17 Inches</MenuItem>
                <MenuItem value={'18"'}>18 Inches</MenuItem>
                <MenuItem value={'19"'}>19 Inches</MenuItem>
                <MenuItem value={'20"'}>20 Inches</MenuItem>
                <MenuItem value={'21"'}>21 Inches</MenuItem>
                <MenuItem value={'22"'}>22 Inches</MenuItem>
                <MenuItem value={'23"'}>23 Inches</MenuItem>
                <MenuItem value={'24"'}>24 Inches</MenuItem>
              </Select>
            ) : (
              <Select onChange={handleDOChange} value={dlo}>
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'11"'}>11 Inches</MenuItem>
                <MenuItem value={'12"'}>12 Inches</MenuItem>
                <MenuItem value={'13"'}>13 Inches</MenuItem>
                <MenuItem value={'14"'}>14 Inches</MenuItem>
                <MenuItem value={'15"'}>15 Inches</MenuItem>
                <MenuItem value={'16"'}>16 Inches</MenuItem>
                <MenuItem value={'17"'}>17 Inches</MenuItem>
                <MenuItem value={'18"'}>18 Inches</MenuItem>
                <MenuItem value={'19"'}>19 Inches</MenuItem>
                <MenuItem value={'20"'}>20 Inches</MenuItem>
                <MenuItem value={'21"'}>21 Inches</MenuItem>
                <MenuItem value={'22"'}>22 Inches</MenuItem>
                <MenuItem value={'23"'}>23 Inches</MenuItem>
                <MenuItem value={'24"'}>24 Inches</MenuItem>
              </Select>
            )}
            <FormHelperText>Required</FormHelperText>
          </StyledFormControl>
        )}
      </ColLayout>

      {layout && (
        <Grow in={true}>
          <StyledImg src={liteImage} alt="Lites Layout" />
        </Grow>
      )}
    </RowLayout>
  );
};

export default DLselection;
